import React from 'react'

export default function AddNewUser() {
  return (
    <div>AddNewUser</div>
  )
}
